import React, { useEffect, useState } from 'react';
import * as componentStyle from './finalProductShowcase.module.scss';
import { Heading } from '../../../interface/header.interface';
import { GatsbyImageInterface } from '../../../interface/image.interface';
import { toast } from 'react-toastify';
import HeadingComponent from '../../HeadingComponent/HeadingComponent';
import ButtonComponent from '../../Home/ButtonComponent/ButtonComponent';
import { navigate } from 'gatsby';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { IoPlayCircleOutline } from 'react-icons/io5';
import ReactPlayer from 'react-player';



interface ButtonInterface {
  buttonContext: string | null;
  slug: string | null;
}
interface ContextInterface {
  label: string | null;
  description: string | null;
}
interface TestimonialInterface {
  quote: string | null;
  ownerData: string | null;
}
interface ImageInterface {
  altText: string | null;
  image: GatsbyImageInterface | null;
}
interface ThumbnailThreeInterface {
  context: string | null;
  link: string | null;
}
interface ThumbnailInterface {
  thumbnailOne: ImageInterface | null;
  thumbnailTwo: ImageInterface | null;
  thumbnailThree: ThumbnailThreeInterface | null;
}
export interface FinalProductProps {
  button: ButtonInterface | null; 
  context: ContextInterface[] | null; 
  description: string | null; 
  descriptionRightSide?: string | null; 
  descriptionTwo?: string | null; 
  heading: Heading[] | null; 
  sectionImage: ImageInterface | null; 
  testimonial: TestimonialInterface | null; 
  thumbnail: ThumbnailInterface | null 
}
interface VideoSources {
  webm: string | null;
  mp4: string | null;
  posterImage: string | null;
  altText: string | null;
}
interface FinalProductInterface {
  context?: FinalProductProps | null;
  videoSources?: VideoSources | null;
}

export default function FinalProductShowcase({ data }: { data: FinalProductInterface | null }) {

  // supported video formats
  const [isHover, setIsHover] = useState<boolean>(false);
  const [supportedFormat, setSupportedFormat] = useState<string | null>(null);

  useEffect(() => {
    const videoElement = document.createElement('video');
    if (videoElement.canPlayType('video/webm') && data?.videoSources?.webm) {
      setSupportedFormat(data.videoSources.webm);
    } else if (videoElement.canPlayType('video/mp4') && data?.videoSources?.mp4) {
      setSupportedFormat(data?.videoSources?.mp4);
    } else {
      toast.warning('Only WebM and MP4 formats are supported.');
    }
  }, [data?.videoSources]);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };


  return (
    <>
      {data?.context?.heading && (
        <>
          {!data?.context?.descriptionRightSide && (
            <section className={componentStyle.finalProductShowcase}>
              <div className={componentStyle.finalProductShowcase__container}>
                <div className={componentStyle.finalProductShowcase__headingArea}>
                  {data?.context?.heading && <HeadingComponent data={data.context.heading} />}
                  {data?.context?.button?.buttonContext && (
                    <div className={componentStyle.finalProductShowcase__buttonArea}>
                      <ButtonComponent 
                        buttonText={data?.context?.button?.buttonContext.toUpperCase()} 
                        type={undefined} 
                        buttonStyle={undefined} 
                        onClick={() => navigate(data?.context?.button?.slug || '#')} 
                        disabled={undefined} 
                        loading={undefined} 
                        className={undefined} 
                      />
                    </div>
                  )}
                </div>

                {data?.context?.description && <div className={componentStyle.finalProductShowcase__headingDescripton} dangerouslySetInnerHTML={{ __html: data.context.description }}></div>}

                <div className={componentStyle.finalProductShowcase__topContextArea}>
                  <ul className={componentStyle.finalProductShowcase__topList}>
                    {data?.context?.context?.map((item, index) => (
                      <li key={`item-${index}`} className={componentStyle.finalProductShowcase__topListItem}>
                        <div className={componentStyle.finalProductShowcase__topItemChild}>
                          <div className={componentStyle.finalProductShowcase__topItemChildHeading}>{item?.label}</div>
                          {item?.description && <div className={componentStyle.finalProductShowcase__topItemChildDescription} dangerouslySetInnerHTML={{ __html: item.description }}></div>}
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div className={componentStyle.finalProductShowcase__quoteArea}>
                    <label className={componentStyle.finalProductShowcase__quoteLabel}>{data?.context?.testimonial?.quote}</label>
                    <span className={componentStyle.finalProductShowcase__quoteOwnerData}>{data?.context?.testimonial?.ownerData}</span>
                  </div>
                </div>

                <div className={componentStyle.finalProductShowcase__contextArea}>
                  {data?.context?.sectionImage?.image && (
                    <div className={componentStyle.finalProductShowcase__sectionImage}>
                      <GatsbyImage image={getImage(data.context.sectionImage.image?.localFile) as IGatsbyImageData} alt={data.context.sectionImage.altText || 'N/A'} />
                    </div>
                  )}

                  <ul className={componentStyle.finalProductShowcase__list}>
                    <li className={componentStyle.finalProductShowcase__listItem}>
                      {data?.context?.thumbnail?.thumbnailOne?.image &&
                        <div className={componentStyle.finalProductShowcase__itemChild}>
                            <div className={componentStyle.finalProductShowcase__itemChildImage}>
                              <GatsbyImage 
                                image={getImage(data?.context?.thumbnail?.thumbnailOne?.image?.localFile) as IGatsbyImageData} 
                                alt={data?.context?.thumbnail?.thumbnailOne?.altText || 'N/A'}
                              />
                            </div>
                        </div>
                      }
                    </li>

                    <li className={componentStyle.finalProductShowcase__listItem}>
                      {data?.context?.thumbnail?.thumbnailTwo?.image &&
                        <div className={componentStyle.finalProductShowcase__itemChild}>
                            <div className={componentStyle.finalProductShowcase__itemChildImage}>
                              <GatsbyImage 
                                image={getImage(data?.context?.thumbnail?.thumbnailTwo?.image?.localFile) as IGatsbyImageData} 
                                alt={data?.context?.thumbnail?.thumbnailTwo?.altText || 'N/A'} 
                              />
                            </div>
                        </div>
                      }
                    </li>

                    <li className={componentStyle.finalProductShowcase__listItem} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                      <a href={data?.context?.thumbnail?.thumbnailThree?.link || '#'} target='_blank' className={componentStyle.finalProductShowcase__itemChild}>
                        <div className={componentStyle.finalProductShowcase__itemIcon}>
                          <IoPlayCircleOutline />
                        </div>
                        <span className={componentStyle.finalProductShowcase__childContext}>{data?.context?.thumbnail?.thumbnailThree?.context || 'N/A'}</span>
                        {isHover &&
                          <div className={ componentStyle.finalProductShowcase__childVideo}>
                            <ReactPlayer
                              url={String(supportedFormat)}
                              playing={true}
                              controls={false}
                              loop={true}
                              muted={true}
                              playsinline={true}
                              width="100%"
                              height="100%"
                            />
                          </div>
                        }
                      </a>
                    </li>
                  </ul>
                </div>

                {data?.context?.descriptionTwo && <div className={componentStyle.finalProductShowcase__descriptonTwo} dangerouslySetInnerHTML={{ __html: data.context.descriptionTwo }}></div>}

              </div>
            </section>
          )}

          {/* -----===== Final Product Showcase V2 =====----- */}
          {data?.context?.descriptionRightSide && (
            <section className={componentStyle.finalProductShowcaseV2}>
              <div className={componentStyle.finalProductShowcaseV2__container}>
                <div className={componentStyle.finalProductShowcaseV2__headingArea}>
                  {data?.context?.heading &&
                    <HeadingComponent data={data.context.heading} />
                  }

                  <div className={componentStyle.finalProductShowcaseV2__headingContext}>
                    {data?.context?.descriptionRightSide && <div className={componentStyle.finalProductShowcaseV2__headingDescripton} dangerouslySetInnerHTML={{ __html: data.context.descriptionRightSide }}></div>}
                    {data?.context?.button?.buttonContext &&
                      <div className={componentStyle.finalProductShowcaseV2__headingButtonArea}>
                        <ButtonComponent 
                          buttonText={data.context?.button.buttonContext.toUpperCase()} 
                          type={undefined} 
                          buttonStyle={undefined} 
                          onClick={() => navigate(data.context?.button?.slug || '#')} 
                          disabled={undefined} 
                          loading={undefined} 
                          className={undefined} 
                        />
                      </div>
                    }
                  </div>
                </div>

                <div className={componentStyle.finalProductShowcaseV2__contextArea}>
                  {data?.context?.sectionImage?.image && (
                    <div className={componentStyle.finalProductShowcaseV2__sectionImage}>
                      <GatsbyImage image={getImage(data.context.sectionImage.image?.localFile) as IGatsbyImageData} alt={data.context.sectionImage.altText || 'N/A'} />
                    </div>
                  )}

                  {data?.context?.thumbnail &&
                    <ul className={componentStyle.finalProductShowcaseV2__list}>
                      <li className={componentStyle.finalProductShowcaseV2__listItem}>
                        {data?.context?.thumbnail?.thumbnailOne?.image &&
                          <div className={componentStyle.finalProductShowcaseV2__itemChild}>
                              <div className={componentStyle.finalProductShowcase__itemChildImage}>
                                <GatsbyImage 
                                  image={getImage(data?.context?.thumbnail?.thumbnailOne?.image?.localFile) as IGatsbyImageData} 
                                  alt={data?.context?.thumbnail?.thumbnailOne?.altText || 'N/A'} 
                                />
                              </div>
                          </div>
                        }
                      </li>

                      <li className={componentStyle.finalProductShowcaseV2__listItem}>
                        {data?.context?.thumbnail?.thumbnailTwo?.image &&
                          <div className={componentStyle.finalProductShowcaseV2__itemChild}>
                              <div className={componentStyle.finalProductShowcase__itemChildImage}>
                                <GatsbyImage 
                                  image={getImage(data?.context?.thumbnail?.thumbnailTwo?.image?.localFile) as IGatsbyImageData} 
                                  alt={data?.context?.thumbnail?.thumbnailTwo?.altText || 'N/A'} 
                                />
                              </div>
                          </div>
                        }
                      </li>

                      <li className={componentStyle.finalProductShowcaseV2__listItem} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <a href={data?.context?.thumbnail?.thumbnailThree?.link || '#'} target='_blank' className={componentStyle.finalProductShowcaseV2__itemChild}>
                          <div className={componentStyle.finalProductShowcaseV2__itemIcon}>
                            <IoPlayCircleOutline />
                          </div>
                          <span className={componentStyle.finalProductShowcaseV2__childContext}>{data?.context?.thumbnail?.thumbnailThree?.context || 'N/A'}</span>
                          {isHover &&
                            <div className={ componentStyle.finalProductShowcaseV2__childVideo}>
                              <ReactPlayer
                                url={String(supportedFormat)}
                                playing={true}
                                controls={false}
                                loop={true}
                                muted={true}
                                playsinline={true}
                                width="100%"
                                height="100%"
                              />
                            </div>
                          }
                        </a>
                      </li>
                    </ul>
                  }
                </div>

              </div>
            </section>
          )}
        </>
      )}
    </>
  )
}
